import Spinner from 'src/javascripts/components/utilities/Spinner';
import Swal from 'sweetalert2';
import {companiesBloodhound, filterTypeahead, filterTypeaheadNoCache} from 'src/javascripts/components/typeaheads/TypeaheadBloodhounds';
import ToastCustom from 'src/javascripts/components/alerts/ToastCustom';
import {noResultsTemplate, logoTemplate} from 'src/javascripts/components/typeaheads/TypeaheadTemplates';
import ManualListTypeahead from 'src/javascripts/components/typeaheads/ManualListTypeahead';
import 'src/javascripts/vendor/typeahead.jquery';
import 'src/javascripts/vendor/bloodhound';

// Must define Bloodhound explicitly here
// https://stackoverflow.com/questions/30750916/how-to-reference-typeahead-and-bloodhound-when-loading-npm-typeahead-js
const Bloodhound = require('src/javascripts/vendor/bloodhound');

export default class CarbonIndex {

  constructor() {}

  render() {
    const accountUrl = $('body').attr('data-account-url');
    const reloadUrl = window.location.pathname;

    // Set function to reload page with params
    const reloadResearch = function(notice = "") {

      // Set params based on filter attributes
      let params = {};
      let data = $('#filtersModal').data();
      $.each(data, function(key, val) {
        if (key.indexOf('filter') !== -1) {
          let k = key.replace("filters", "")
          k = k.replace(/[A-Z]/g, letter => `_${letter.toLowerCase()}`);
          k = k.slice(1);
          params[k] = val
        }
      });

      // Set param to auto-show modal
      params['as'] = 'true';

      // Set scroll position of filters
      let modalBody = $("#filtersModal").find('.modal-body');
      let scrollFilter = modalBody.scrollTop();
      params['sp'] = scrollFilter;

      // Reload with params
      return Turbo.visit(reloadUrl + '?' + $.param(params));

    }

    filterTypeahead('.portfolio-typeahead', 'portfolio', '/' + accountUrl + '/portfolios/search?', 144, 'generic');
    filterTypeahead('.funds-typeahead', 'funds', '/funds/search?', 85, 'logo');

    // Manual typeaheads
    $('.manual-list-typeahead').each(function(el){
      let id = $(this).attr('id');
      let t = new ManualListTypeahead(el);
      t.render(id)
    });

    // On selecting a fund as benchmark
    $('.clear-typeahead').click(function() {
      let t = $(this).closest('.form-group').find('.typeahead');
      t.typeahead('val', '');
      t.focus();
    })

    // On typeahead select, create a filter
    $('.research-filters-typeahead').bind('typeahead:beforeselect typeahead:autocomplete', function(ev, suggestion) {
      ev.preventDefault();
      $('.tooltip').tooltip('hide');

      // Set value
      let val;
      if (typeof suggestion.record_id !== 'undefined') {
        val = suggestion.record_id;
      } else if (typeof suggestion.value !== 'undefined') {
        val = suggestion.value;
      } else {
        val = suggestion;
      }

      // Set record on filters modal
      let key = $(this).attr('data-key');
      let currentFilter = $('#filtersModal').data('filters-' + key);
      let updateMethod = $(this).attr('data-update-method');
      if ((typeof updateMethod !== 'undefined') && (updateMethod === 'add')) {
        let updatedFiltVal = currentFilter + ',' + val.toLowerCase();
        $('#filtersModal').data('filters-' + key, updatedFiltVal);

      } else {
        $('#filtersModal').data('filters-' + key, val);
      }

      // Remove any params/keys specified
      // For example, if we want portfolio_id, fund_id, OR list_id
      let removeKeys = $(this).attr('data-remove-keys');
      if (typeof removeKeys !== 'undefined') {
        removeKeys = JSON.parse(removeKeys);
        $.each(removeKeys, function(k,v) {
          $('#filtersModal').removeData('filters-' + v);
        })
      }

      // Re-load with parameters
      reloadResearch();

      // Blur typeahead
      $(this).blur();

    });

    // Radio buttons on change
    $('.custom-control-input').on('change', function(ev, suggestion) {
      let val = $(this).val();
      let key = $(this).attr('data-key');
      $('#filtersModal').data('filters-' + key, val);
      reloadResearch();
    })

  }

}